export default "__VITE_ASSET__DmQYR_FO__"